import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Renders a teammate name as a click-through link to their profile page
 * (/employees/:user_id). Falls back to plain text when we don't have a
 * user_id (e.g. free-text mention, unknown employee).
 *
 * Usage:
 *   <UserLink userId={s.employee_id} name={nameOf(s.employee_id)} />
 *   <UserLink user={managerObj} />                // shorthand
 */
const UserLink = ({ userId, user, name, className = "", stopPropagation = true, children, testid }) => {
    const navigate = useNavigate();
    const uid = userId || user?.user_id;
    const label = children || name || user?.name || user?.email || "—";
    if (!uid) {
        return <span className={className}>{label}</span>;
    }
    const cls = `hover:text-[#25908A] hover:underline underline-offset-2 decoration-[#2EB4AC]/40 transition-colors cursor-pointer ${className}`;
    return (
        <button
            type="button"
            onClick={(e) => {
                if (stopPropagation) e.stopPropagation();
                navigate(`/employees/${uid}`);
            }}
            data-testid={testid || `user-link-${uid}`}
            className={cls}
            title={`View ${label}'s profile`}
        >
            {label}
        </button>
    );
};

export default UserLink;
